// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"6af93ff7","215":"c29b568b","453":"69c53734","658":"39d4172c","799":"fdc75cd5","803":"c23775a0","855":"ba21a776"}[chunkId] + ".chunk.js";
};